import {Component, OnInit, Input, ViewChild, ElementRef, HostListener} from '@angular/core';
import {BarChartConfigurations} from "../../charts/bar-chart/bar-chart.models";
import {TitleConfigurations, TitleLineConfigurations} from "../title/title.configurations";
import {NewsConfigurations} from "../news/news.configurations";
import {KlaHttpService} from "../services/kla.http.service";
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { BarChartComponent } from 'app/shared/charts/bar-chart/bar-chart.component';
import { NewsComponent } from '../news/news.component';

@Component({
  selector: 'kla-bar-graph',
  templateUrl: './bar-graph.component.html',
  styleUrls: ['./bar-graph.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, BarChartComponent, NewsComponent ]
})
export class BarGraphComponent implements OnInit {

  @Input()
  public width: number;

  @Input()
  public height: number;

  @Input()
  public config: {
    barChart: BarChartConfigurations,
    title: TitleConfigurations,
    newsId: string,
    chartId: string
  };

  @Input()
  public lineConfig: TitleLineConfigurations;

  @ViewChild('panel', {static: true})
  public panel:ElementRef;

  public listOfNews: Array<NewsConfigurations> = [];

  constructor(private http: KlaHttpService) { }

  ngOnInit() {
    this.findChartData();
    this.findNews();
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }

  private findChartData() {
    this.http.getChartData("kla-bar-chart", this.config.chartId).subscribe(
      (data) => {
        this.config.barChart = data;
        if (!this.config.barChart) {
          console.error("Please provide bar chart configurations");
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  private findNews() {
    this.http.getNewsData(this.config.newsId).subscribe(
      (data) => {
        this.listOfNews = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  private resize() {
    let rectangle = this.panel.nativeElement.getBoundingClientRect();
    let width = rectangle.width - 60;
    width  = width < 600 ? 600 : width;
    this.width = width;
    this.height = width*2/3;
  }
}
